import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CommissionFilters = ({ filters, onFiltersChange, onReset }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'pending', label: 'En attente' },
    { value: 'paid', label: 'Payé' },
    { value: 'processing', label: 'En cours' },
    { value: 'disputed', label: 'Contesté' }
  ];

  const typeOptions = [
    { value: 'all', label: 'Tous les types' },
    { value: 'booking', label: 'Réservation' },
    { value: 'referral', label: 'Parrainage' },
    { value: 'bonus', label: 'Bonus' },
    { value: 'recurring', label: 'Récurrent' }
  ];

  const venueOptions = [
    { value: 'all', label: 'Tous les lieux' },
    { value: 'club', label: 'Clubs' },
    { value: 'festival', label: 'Festivals' },
    { value: 'bar', label: 'Bars/Restaurants' },
    { value: 'private', label: 'Événements privés' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground">Filtres</h3>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onReset}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Réinitialiser
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
          >
            {isExpanded ? 'Masquer' : 'Plus de filtres'}
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <Input
            label="Date de début"
            type="date"
            value={filters?.startDate}
            onChange={(e) => handleFilterChange('startDate', e?.target?.value)}
          />
        </div>
        <div>
          <Input
            label="Date de fin"
            type="date"
            value={filters?.endDate}
            onChange={(e) => handleFilterChange('endDate', e?.target?.value)}
          />
        </div>
        <div>
          <Select
            label="Statut"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => handleFilterChange('status', value)}
          />
        </div>
        <div>
          <Select
            label="Type"
            options={typeOptions}
            value={filters?.type}
            onChange={(value) => handleFilterChange('type', value)}
          />
        </div>
      </div>
      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 pt-4 border-t border-border">
          <div>
            <Select
              label="Catégorie de lieu"
              options={venueOptions}
              value={filters?.venue}
              onChange={(value) => handleFilterChange('venue', value)}
            />
          </div>
          <div>
            <Input
              label="Montant minimum (€)"
              type="number"
              placeholder="0,00"
              value={filters?.minAmount}
              onChange={(e) => handleFilterChange('minAmount', e?.target?.value)}
            />
          </div>
          <div>
            <Input
              label="Montant maximum (€)"
              type="number"
              placeholder="1000,00"
              value={filters?.maxAmount}
              onChange={(e) => handleFilterChange('maxAmount', e?.target?.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CommissionFilters;